export default __webpack_public_path__ + "static/aa1-1ac529853a1e07150008b25d51e4c207.png";